"use client";

import React, { useContext, useRef } from "react";
import Link from "next/link";
import Image from "next/image";
import MyContext from "@/app/(pages)/Context/MyContext";

export const dynamic = "force-dynamic";

export const LatestBlogs = () => {
  const myref = useRef();
  const { blogList } = useContext(MyContext);

  let blogLists = blogList.slice(0, 3);
  return (
    <>
      <div className="grid w-full grid-cols-1 md:gap-10 gap-5 md:grid-cols-2 2xl:grid-cols-3">
        {blogLists?.map((blog, ind) => {
          return (
            <Link
              href={`/blog/${blog?.attributes?.slug}`}
              key={blog?.attributes?.slug || ind}
              className="group"
            >
              <div className="grid w-full grid-cols-1 gap-1 hover:scale-105 transition-all duration-300 ease-in-out">
                <div className="relative w-full rounded-xl" ref={myref}>
                  <Image
                    className="object-cover py-1 transition-all duration-300 ease-in-out drop-shadow-sm w-full rounded-xl"
                    src={`${process.env.NEXT_PUBLIC_STRAPI_URL}${blog?.attributes?.titleImage?.data?.attributes.url}`}
                    alt={blog?.attributes?.title}
                    width={300}
                    height={300}
                  />
                </div>

                <div className="py-2 text-lg transition-all duration-300 ease-in-out drop-shadow-sm text-ellipsis text-black">
                  <div className="flex md:justify-start gap-2 flex-wrap">
                    {blog?.attributes?.tags?.data?.map((itemName, ind) => (
                      <h2
                        key={itemName?.attributes?.uid || ind}
                        className="bg-[#EFE8FC] text-regal-purple md:py-2 py-1 md:px-4 px-2 text-sm w-fit rounded-md"
                      >
                        {itemName?.attributes?.name}
                      </h2>
                    ))}
                  </div>

                  <h3 className="text-black font-medium my-2 text-sm md:text-base md:text-start text-center changeText relative group">
                    {blog?.attributes?.title}
                  </h3>
                  <div
                    className="text-[#747474] md:text-sm text-xs md:text-start text-center relative group"
                  >
                    {blog?.attributes?.seo?.metaDescription}
                  </div>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </>
  );
};
